import * as URLConfig from "@frameworks/web/config/domain";
const config = URLConfig.config;
const configURL = {
    jwttokenfornesttraderUrl: config.web_mw + "Account/jwttokenfornesttrader",
    retriveAccountData: config.jmw + config.jmw_content + "adhoc/retrieve/data",
    retrieveExtPlatAccData: config.jmw + config.jmw_login + "accounts/logindata/web",
};
const commonUrlConfig = Object.assign(Object.assign({}, configURL), { jwttokenfornesttraderUrl: config.web_mw + "Account/jwttokenfornesttrader" });
export default commonUrlConfig;
